import { IAppCurrency } from "@App/types";
import { components } from "@api/schema";
import { ToastProps } from "@UI/hooks/useToast";
import { DrawerProps } from "@UI/Components/Drawer/Drawer";
import { ButtonProps } from "@UI/Components/Button/Button";
import { RateProps } from "@Shared/Components/Rate/Rate";
import { TextProps } from "@UI/Components/Text/Text";

export interface IServiceOfferModalWithButtonProps
  extends Pick<RateProps, "isShortFormat"> {
  candidate: ICandidate;
  offerWithdrawn: boolean;
  buttonSize: ButtonProps["size"];
  totalPrice?: string;
}

export interface ICandidateOfferModalProps
  extends Pick<DrawerProps, "isOpen" | "onClose"> {
  onDeclineOfferModalOpen: (
    conversationId: ICandidate["conversationId"]
  ) => void;
  candidate: ICandidate;
}

export interface ICandidateTransparentPriceDetailsProps
  extends Pick<RateProps, "isShortFormat"> {
  billingUnit: ICandidate["serviceOffer"]["billingUnit"];
  totalPrice: number;
  totalExpense: number;
  rateCurrency: ICandidate["serviceOffer"]["rateCurrency"];
  totalPriceStyle?: TextProps;
  isSubscribed: boolean;
  onClick?: () => void;
}
export interface ICandidateCardProps {
  onCandidateOfferModalOpen: ICandidateOfferModalProps["onDeclineOfferModalOpen"];
  removeUnreadIndicatorFromConversation: ICandidateOfferModalProps["onDeclineOfferModalOpen"];
}

export type IToastProps = (
  toastData: Pick<ToastProps, "status" | "description">
) => void;

export type IDeclineServiceProviderParams = {
  conversationId?: number;
  reason?: string;
  otherReason?: string;
  serviceProviderName: string;
};

export interface IServiceRequest {
  id: number;
  description: string;
  placeName: string;
  pictures: {
    normal: string;
    thumb: string;
  }[];
  postedDate: string;
  pro_only: boolean;
  appliedServiceProvidersCount: number;
  pCategory: string;
  pCategoryId: number;
  sCategory: string;
  sCategoryId: number;
  level3Categories: string[];
  state: components["schemas"]["serviceRequest"]["state"];
  title: string;
  clientName: string;
}

export interface IServiceRequestProps {
  serviceRequest: IServiceRequest;
}

interface IFee {
  name: string;
  type: string;
  amountCents: number;
  amountCurrency: string;
  details: string;
  enabled: boolean;
}

export enum EstimationState {
  REFUSED = "quote_waiting",
  WAITING = "quote_refused",
  NOT_SENT = "quote_not_sent",
  ACCEPTED = "quote_accepted",
}
export interface ICandidate {
  id: number;
  conversationId: number;
  firstName: string;
  lastName: string;
  profilePicture: string;
  ratingsAverage: number;
  ratingsCount: number;
  pro: boolean;
  superTalent: boolean;
  distance: number;
  similarRequestCount: number;
  offerAsked: boolean;
  offerWithdrawn: boolean;
  unreadConversationCommentsCount: number;
  serviceOffer: {
    id: number;
    offersFreeEstimation: boolean;
    rateCents: number;
    serviceFeesCents: number;
    expensesCents?: number;
    expensesFeesCents?: number;
    rateCurrency: IAppCurrency;
    rateType: components["schemas"]["serviceOffer"]["rateType"];
    estimationState?: EstimationState;
    serviceProviderId: number;
    conversationId: number;
    state: components["schemas"]["serviceOffer"]["state"];
    serviceRequestId: number;
    billingUnit: components["schemas"]["serviceOffer"]["billingUnit"];
    billingCount: components["schemas"]["serviceOffer"]["billingCount"];
    fees: IFee[];
    expenses?: {
      id: number;
      amountCents: number;
      amountCurrency: string;
      description: string;
      vatRate: number;
      serviceOfferId: number;
      fees: IFee[];
    }[];
  };
}

export const CandidateFilters = {
  recommended: "recommended",
  last_updated: "last_updated",
} as const;

export type ICandidateFilter = keyof typeof CandidateFilters;
export interface IServiceRequestCandidateParams {
  serviceRequestId: number | string;
  sortBy: ICandidateFilter;
}
